import { render, staticRenderFns } from "./asset.vue?vue&type=template&id=01f7cea6&scoped=true&"
import script from "./asset.vue?vue&type=script&lang=js&"
export * from "./asset.vue?vue&type=script&lang=js&"
import style0 from "./asset.vue?vue&type=style&index=0&id=01f7cea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7cea6",
  null
  
)

export default component.exports